import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CommentsLibrary } from '@exploreorg/explore-comments';
import ReduxModal, { modal } from 'react-redux-modal';
import { commentsConfig } from '../utils';
import { LoginModalView } from '../components/Modals';
import { Loader } from '../components';

const conf = commentsConfig();

class PopComments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.refreshComments = this.refreshComments.bind(this);
  }
  handleNewComment(comment) {
    console.log(comment.text);
  }

  ssoConfig() {
    const baseUrl = window.location.origin;
    return {
      name: 'explore.org',
      button: 'https://explore.org/images/disqus-sso-login-button.png',
      icon: 'https://explore.org/images/favicon.png',
      url: `${baseUrl}/accounts/login/`,
      logout: `${baseUrl}/accounts/logout/`,
      width: '800',
      height: '400',
    };
  }

  openLogin(e) {
    e.preventDefault();
    modal.add(LoginModalView, { title: '', size: 'medium', hideTitleBar: true, id: 'login' });
  }
  refreshComments() {
    this.setState({ loading: true });
    setTimeout(() => this.setState({ loading: false }), 500);
  }

  render() {
    const {
      livecamId,
      commentToken,
      pageUrl,
    } = this.props;
    const { loading } = this.state;
    const commentModuleParameters = {
      theme: 'light',
      token: commentToken,
      livecamId: String(livecamId),
    };

    return (
      <div style={{ backgroundColor: 'white', padding: '20px 30px' }}>
        <div className="d-flex flex-wrap justify-content-end mb-1 mx-3">
          <button className="btn btn-secondary btn-sm d-inline-block" onClick={this.refreshComments}>
            <span className="icon font-weight-bold" style={{ fontSize: '1.35em' }}>⟳</span> Refresh comments
          </button>
        </div>
        {loading && (
          <div className="position-relative" style={{ height: '200px' }}><Loader fill dark style={{ height: 200 }}/>
          </div>)}
        {!loading && (
          <CommentsLibrary
            config={conf}
            {...commentModuleParameters}
            pageUrl={pageUrl}
            onLoginClick={this.openLogin}
          />
        )}
        <ReduxModal/>
      </div>
    );
  }
}

PopComments.defaultProps = {
  shortName: 'exploreorg',
  id: '',
  title: '',
  categoryId: '',
  remoteAuthS3: '',
  isAuthenticated: false,
};

PopComments.propTypes = {
  shortName: PropTypes.string,
  id: PropTypes.string,
  remoteAuthS3: PropTypes.string,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    commentsFullWidth: state.uiPreferences.commentsFullWidth,
    livecamId: state.currentItem.data.id,
    commentToken: state.auth.commentToken,
    pageUrl: state.currentItem.data.canonical_url,
  };
};

export default connect(mapStateToProps)(PopComments);
